type ToastProps = {
  message: string | null;
};

export default function Toast({ message }: ToastProps) {
  if (!message) return null;
  return (
    <div className="fixed left-1/2 -translate-x-1/2 bottom-8 z-[60] px-4 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm animate-rise">
      {message}
    </div>
  );
}